// modules/inicio/api/axiosClient.js
// Instancia de axios compartida: agrega el token JWT automáticamente a
// cada petición (si existe) y centraliza la base URL del backend.

import axios from "axios";

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axiosClient;
